import React from 'react';
import { useLocale } from 'locale';
import Tooltip from 'ds/components/tooltip';
import { Text } from 'ds/components/typography';
import Questionmark from 'assets/svg/question-border.svg';
import TipsIcon from 'assets/svg/tips-prices.svg';
import { IPriceEstimationRecord } from 'store/state/selectors/insights/prices';
import PriceEstimationChart from './chart';
import { Wrapper, PriceEstimationTitle, TipWrapper, TooltipWrapper } from './styled';
import { Question, TooltipText } from 'components/widget/prices/section/styled';

interface PriceEstimationProps {
  estimatedPrice?: number;
  minEstimation: number;
  maxEstimation: number;
  minPrice: number;
  maxPrice: number;
  currentRecord: IPriceEstimationRecord;
  records: IPriceEstimationRecord[];
  hideEstimationAdditionalInfo?: boolean;
}

const PriceEstimation: React.FC<PriceEstimationProps> = props => {
  const {
    estimatedPrice,
    minEstimation,
    maxEstimation,
    currentRecord,
    minPrice,
    maxPrice,
    records,
    hideEstimationAdditionalInfo,
  } = props;

  if (!(records && records.length)) return null;

  const { t } = useLocale();
  const isPriceHigher = currentRecord ? currentRecord.price > maxEstimation : false;

  const toolTip = (
    <TooltipWrapper>
      <Tooltip
        placement="left"
        tooltip={<TooltipText dangerouslySetInnerHTML={{ __html: t('widget.prices.estimation.tooltip') }}/>}
      >
        <Question>
          <Questionmark/>
        </Question>
      </Tooltip>
    </TooltipWrapper>
  );

  return (
    <Wrapper>
      <PriceEstimationTitle weight="bold">
        {t('widget.prices.estimation.title')}
      </PriceEstimationTitle>
      {currentRecord ? (
        <PriceEstimationChart
          minEstimation={minEstimation}
          maxEstimation={maxEstimation}
          estimation={estimatedPrice}
          record={currentRecord}
          minPrice={minPrice}
          maxPrice={maxPrice}
          hideAdditionalInfo={hideEstimationAdditionalInfo}
        />
      ) : null}
      <TipWrapper>
        <TipsIcon />
        <div style={{ alignSelf: isPriceHigher ? 'flex-start' : 'center' }}>
          {isPriceHigher ? (
            <>
              <Text weight="bold">{t('widget.prices.estimation.actualHigherTitle')}</Text>
              <Text>
                {t('widget.prices.estimation.actualHigherText')}
                {toolTip}
              </Text>
            </>
          ) : (
            <Text>
              {t('widget.prices.estimation.description')}
              {toolTip}
            </Text>
          )}
        </div>
      </TipWrapper>
    </Wrapper>
  );
};

export default PriceEstimation;
